let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bC7Er")).then(() => parcelRequire('7jOBk'));